'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var concat = require('../iterable/concat');
var map = require('../iterable/map');

var range = function range(start, stop, step) {
  if (start < stop && start + step < stop) {
    return concat([start], range(start + step, stop, step));
  } else if (start > stop && start - step > stop) {
    return concat([start], range(start - step, stop, step));
  } else if (start === stop) {
    return [];
  }
  return [start];
};

module.exports = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var _map = map(args, Math.round),
      _map2 = _slicedToArray(_map, 3),
      start = _map2[0],
      stop = _map2[1],
      step = _map2[2];

  step = Math.abs(step) || 1;
  if (!args.length) {
    return [];
  } else if (args.length === 1) {
    return range(0, start, step);
  }
  return range(start, stop, step);
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/array/range.js
// module id = 2166
// module chunks = 37